import * as React from "react";
const SvgFiRrOperation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-operation_svg__a)">
      <path
        fill="#062147"
        d="M18.062 8.5a1 1 0 0 0-1.366-.366l-.973.562A4.97 4.97 0 0 0 13 7.102V6.001a1 1 0 0 0-2 0v1.101a5 5 0 0 0-2.723 1.594l-.973-.562a1 1 0 0 0-1 1.732l.974.562A5 5 0 0 0 7 12c0 .553.111 1.075.278 1.572l-.974.562a1 1 0 0 0 1 1.732l.973-.562A4.97 4.97 0 0 0 11 16.898v1.101a1 1 0 0 0 2 0v-1.101a5 5 0 0 0 2.723-1.594l.973.562a.997.997 0 0 0 1.366-.366 1 1 0 0 0-.366-1.366l-.974-.562A5 5 0 0 0 17 12c0-.553-.11-1.075-.278-1.572l.974-.562a1 1 0 0 0 .366-1.366M12 15c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3M1.996 11.09a1 1 0 1 1-1.992-.18C.556 4.792 5.825 0 12 0c2.971 0 5.817 1.129 8 3.08V1a1 1 0 0 1 2 0v4c0 1.103-.897 2-2 2h-4a1 1 0 0 1 0-2h3.123A10.04 10.04 0 0 0 12 2C6.85 2 2.456 5.993 1.996 11.09m22 2C23.444 19.208 18.176 24 12 24c-2.97 0-5.817-1.129-8-3.08V23a1 1 0 0 1-2 0v-4c0-1.103.897-2 2-2h4a1 1 0 0 1 0 2H4.877c1.867 1.893 4.435 3 7.123 3 5.15 0 9.544-3.993 10.004-9.09a1 1 0 0 1 1.992.18"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-operation_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrOperation;
